const updateCollectionDocument = async (collectionRef, docId, updatingObject) => {
  await collectionRef.doc(docId).update(updatingObject);
};
export default updateCollectionDocument;
